import { Rank } from '../../sim/defs';
import { defineEnemy, Motion } from '../schema';

/** E-ORG1 — BANC. Le professeur de la FORME collective.
 *
 *  Un banc n'est pas une nuée. La Mite tombe droit, chacune pour soi : on la
 *  cueille sans avoir à la lire. Le Banc ONDULE ensemble — même fréquence, mais
 *  chaque unité entrée un instant après la précédente, si bien que le groupe
 *  n'avance pas en bloc mais en VAGUE qui court le long de la rangée. La menace
 *  n'est aucune de ses unités, triviales prises à part ; c'est le mur mouvant
 *  qu'elles dessinent ensemble.
 *
 *  ── Ce qu'il enseigne ──
 *  À lire un ensemble plutôt qu'un individu, et à se déplacer AVEC lui. Le
 *  réflexe de viser la case vide entre deux corps échoue : le temps de
 *  l'atteindre, la case a glissé, portée par l'ondulation commune. Le joueur qui
 *  accompagne le sens de la vague la traverse sans jamais s'arrêter ; celui qui
 *  la combat corps par corps se fait rattraper par le suivant. C'est la bascule
 *  du trou glissant du Tisseur, écrite cette fois avec des corps et non avec un
 *  mur de balles.
 *
 *  ── Pourquoi popcorn, et sans tir ──
 *  Chaque unité meurt d'un impact et ne tire jamais : le Banc ne demande pas
 *  d'esquiver des projectiles mais de LIRE une géométrie vivante. Lui ajouter un
 *  rideau brouillerait la seule chose à lire — le dessin de la vague. Et le rang
 *  popcorn garde le gel à zéro : une poignée de morts coup sur coup ne doit pas
 *  hacher l'image (règle sacrée, PLAN.md §6.2).
 *
 *  ── ⚠️ La cohésion se joue à l'ARRIVÉE ──
 *  L'ondulation est portée par le moteur (Sine), mais la VAGUE — le décalage de
 *  phase d'une unité à l'autre — naît de la manière dont le Banc entre en scène :
 *  une file rapprochée, jamais un bloc simultané. Un Banc lâché tout d'un coup
 *  oscillerait à l'unisson et ne serait qu'un rideau de corps rigide ; c'est
 *  l'échelonnement de la vague vitrine qui en fait un être vivant. */
export default defineEnemy({
  id: 'banc',
  rank: Rank.Popcorn,
  hp: 24,
  visualRadius: 16,
  score: 40,
  telegraph: 0.7,
  drops: 1,
  // Descente modérée pour laisser le temps de lire l'ondulation ; amplitude
  // large et fréquence vive pour que la vague se voie franchement.
  motion: { kind: Motion.Sine, speed: 200, amplitude: 90, frequency: 1.2 },
});
